// src/components/Header.js
import React from "react";
import { useMsal } from "@azure/msal-react";

export function Header({ userName, activeTab, onTabChange }) {
  const { instance } = useMsal();
  const initials = userName
    .split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <header className="hub-header">
      <div className="header-inner">
        <div className="header-logo">
          <img src="/assets/logo.png" alt="Stackroute | RPS" className="header-logo-img" />
        </div>
        <nav className="header-nav">
          <button
            type="button"
            className={`nav-link ${activeTab === "catalogue" ? "nav-link--active" : ""}`}
            onClick={() => onTabChange("catalogue")}
          >
            Practice
          </button>
          <button
            type="button"
            className={`nav-link ${activeTab === "practiceoverview" ? "nav-link--active" : ""}`}
            onClick={() => onTabChange("practiceoverview")}
          >
            Practice Overview
          </button>
          <button
            type="button"
            className={`nav-link ${activeTab === "oem" ? "nav-link--active" : ""}`}
            onClick={() => onTabChange("oem")}
          >
            OEM
          </button>
          <button
            type="button"
            className={`nav-link ${activeTab === "dashboard" ? "nav-link--active" : ""}`}
            onClick={() => onTabChange("dashboard")}
          >
            Dashboard
          </button>
        </nav>
        <div className="header-user">
          <div className="user-avatar" title={userName}>{initials}</div>
          <button className="signout-btn" onClick={() => instance.logoutRedirect()} title="Sign out">
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
